import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FeatureUpgradePanel from './FeatureUpgradePanel';


export default class SubscribePlan extends Component {
  static propTypes = {
    upgrade: PropTypes.bool,
    featureKey: PropTypes.string,
    contextLabel: PropTypes.string,
    onClose: PropTypes.func,
  }
  render() {
    return <FeatureUpgradePanel featureKey={this.props.featureKey} contextLabel={this.props.contextLabel} isOpen={true} onClose={this.props.onClose || (() => {})} />;
  }
}
